import { Fragment, useContext } from "react";
import { UL } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";
import Notifications from "./Notifiations";
import { UserProfile } from "../../../Constant";
import Userprofile from "./profile";
import DownloadIcon from "../../../Components/Common/svg/download";
import { useNavigate } from "react-router-dom";

const Rightbar = () => {
  const { sidebarResponsive } = useContext(CustomizerContext);
  const navigate =useNavigate()
  const user = JSON.parse(localStorage.getItem("user")) ||{} 
  const company_id =user.company_id
  //full screen function
  function goFull() {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  return (
    <Fragment>
      <div className="nav-right col pull-right right-menu p-0">
        <UL
          attrUL={{
            className: `simple-list d-flex flex-row nav-menus ${
              sidebarResponsive ? "open" : ""
            }`,
          }}
        >   
        
{/*       
          <LI>
            <a className="text-dark" href="#javascript" onClick={goFull}>
              <Maximize />
            </a>
          </LI>   */}
          {/* <MoonLight /> */}
         
          {/* <Bookmarks /> */} 
          <div  onClick={()=>navigate(`${process.env.PUBLIC_URL}/downloads`)}>
      <DownloadIcon  />
          </div>
     
          <Notifications /> 
          <Userprofile/>
        
          {/* <LanguageClass /> */}
          {/* <MessageDrop /> */} 
       
        
        </UL>
      </div>
    </Fragment>
  );
};

export default Rightbar;
